import { LngLatLike } from 'maplibre-gl';
import { useEffect } from 'react';

import { MAP_ZOOM_FLY_TO } from '@/modules/MAP_ZOOMS';
import { useSignSupportQuery } from '@/queries/useSignSupportQuery';
import { useMapStore } from '@/stores/useMapStore';

export const useSignSupportFlyTo = () => {
  const { data: signSupport } = useSignSupportQuery();

  const map = useMapStore((store) => store.map);

  useEffect(() => {
    const longitude = signSupport?.geometry.coordinates[0];
    const latitude = signSupport?.geometry.coordinates[1];

    const center: LngLatLike | undefined =
      longitude !== undefined && latitude !== undefined ? [longitude, latitude] : undefined;

    if (center) {
      map.current?.flyTo({
        center,
        padding: { right: Math.min(520, window.innerWidth * 0.3), top: 0, bottom: 0, left: 0 },
        ...(map.current?.getZoom() < MAP_ZOOM_FLY_TO && { zoom: MAP_ZOOM_FLY_TO }),
      });
    }
  }, [signSupport, map]);
};
